import React from 'react';
import { makeStyles } from '@mui/styles';
import Container from '@mui/material/Container';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const getSpacingSize = size => (size === 'regular' ? 12 : 4);

const useStyles = makeStyles(theme => ({
  root: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: '#ffffff',
    paddingTop: ({ spacing }) => theme.spacing(getSpacingSize(spacing)),
    paddingBottom: ({ spacing }) => theme.spacing(getSpacingSize(spacing)),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(5),
    },
  },
}));

const PageSection = ({ children, maxWidth, disablePadding, ...props }) => {
  const classes = useStyles(props);

  return (
    <section>
      <div className={classes.root} {...props}>
        <Container maxWidth={maxWidth} disableGutters={true}>
          <Box p={disablePadding ? 0 : 2}>{children}</Box>
        </Container>
      </div>
    </section>
  );
};

PageSection.propTypes = {
  maxWidth: PropTypes.any,
  disablePadding: PropTypes.bool,
  spacing: PropTypes.oneOf(['regular', 'slim']),
};

PageSection.defaultProps = {
  maxWidth: false,
  disablePadding: false,
  spacing: 'regular',
};

export default PageSection;
